import { c as _c } from "react/compiler-runtime";
import { CircularProgress, NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";
/**
 * A person: their avatar to the left of their name. Hovering the avatar shows the same user card
 * as the members table, with a button to open the profile page.
 */
export function InfoBarPerson(t0) {
  const $ = _c(12);
  const {
    member,
    name,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      gap: 1,
      minWidth: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== member) {
    t3 = member && <Box sx={{
      display: "flex",
      flex: "none"
    }} onClick={_temp}><UserAvatarWithMenu member={member} /></Box>;
    $[1] = member;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: "1.125rem",
      fontWeight: "bold",
      color: "primary.main"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== name) {
    t5 = <Text variant="bodyM" shouldElide={true} className={NO_TRANSLATE_CLASS} sx={t4}>{name}</Text>;
    $[4] = name;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isLoading) {
    t6 = isLoading && <CircularProgress size="1rem" />;
    $[6] = isLoading;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t5 || $[10] !== t6) {
    t7 = <Box sx={t2}>{t3}{t5}{t6}</Box>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(event) {
  return event.stopPropagation();
}